// Lane B9 S12's words: the archived banner, the Status chips on the Requisitions list and the closed-reason filter of
// archive search (CR-060: "Filled/Cancelled archive immediately and remain searchable/reportable/auditable/reopenable.").
// Every entry quotes his glossary or the DS row that carries his words; the D0 label suites discover this module (a
// lane folder of src/views) and hold it to their rules. S11 owns views/b9/labels.ts; these words live in their own
// folder so the two slices never edit one file (map D-P11).

import { defineLabels, template } from "@/mc/labels";

const ARCHIVE = '| Archived / Archive | "Filled/Cancelled archive immediately and remain searchable/reportable/auditable/reopenable."';
const REOPEN = '| Reopen Pending / Reopened | same; "reopen preserves previous closure history."';
const CHAIN = '"Statuses / workflow: Offer Accepted -> Ready for HRIS -> HRIS Hired -> Filled -> Archived."';
const REASON = '| Reason | required on Hold, Pass, override, posting-strategy change, cancellation, decline, withdrawal, panel-change rejection: "Reason stored".';
/** DS row 81 (`banner.neutral`), its his-words cell. */
const BANNER = "| *Archived {date} · searchable, reportable, auditable, reopenable* · *Cancelled* |";

/** The Status chips (D18: "Requisitions chip *Status: Archived* (+ *Filled · Cancelled · Reopened*)"), keyed as the chips. */
export const ARCHIVE_CHIP_LABELS = /* @__PURE__ */ defineLabels({
  archived: { text: "Archived" },
  filled: { text: "Filled" },
  cancelled: { text: "Cancelled" },
  reopened: { text: "Reopened" },
});

/** The archived page's words. */
export const ARCHIVE_LABELS = /* @__PURE__ */ defineLabels({
  status: { text: "Status" },
  reopen: { text: "Reopen" },
  reason: { text: "Reason" },
  fourWords: { text: "searchable/reportable/auditable/reopenable" },
});

/** The banner sentence, DS row 81: *Archived {date} · searchable, reportable, auditable, reopenable*. */
export const ARCHIVED_ON = /* @__PURE__ */ template({ text: "Archived {date} · searchable, reportable, auditable, reopenable" 

});
